import { useEffect, useRef, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Story from "@/components/Story";
import Venue from "@/components/Venue";
import Wishlist from "@/components/Wishlist";
import Gallery from "@/components/Gallery";
import Rsvp from "@/components/Rsvp";
import Footer from "@/components/Footer";
import AdminPage from "@/components/AdminPage";
import MusicPlayer from "@/components/MusicPlayer";

function Home() {
  const lenisRef = useRef(null);

  useEffect(() => {
    document.title = "Federica & Alessandro — 22 Maggio 2027";
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((id) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(`#${id}`, { offset: -72, duration: 1.5 });
    }
  }, []);

  return (
    <div className="min-h-screen bg-panna text-[#2D2A26] antialiased overflow-x-hidden">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <Marquee />
        <Story />
        <Venue />
        <Wishlist />
        <Gallery />
        <Rsvp />
      </main>
      <Footer onNavigate={scrollTo} />
      <MusicPlayer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/area-sposi" element={<AdminPage />} />
      </Routes>
      <Toaster position="bottom-center" richColors />
    </BrowserRouter>
  );
}

export default App;
